module.exports = __webpack_public_path__ + "assets/img/Earlytrade-Website.54be2825.webp";